import { setupServiceInfo } from '@estee/elc-universal-utils';
import serviceNames, { RampService } from '~setup/RampService';
import { ELC_RAMP, RAMP_SOCIAL_PROFILE } from '@estee/elc-service-view-names';
import { ServiceManager } from '@estee/elc-service';
import { serviceBusBaseClass } from '~setup/ServiceBus';

setupServiceInfo(__serviceInfo__);

const { name, version } = __serviceInfo__;

RampService.setViews(name, name.replace(/-/g, '_'), version, [ELC_RAMP, RAMP_SOCIAL_PROFILE]);

ServiceManager.setServiceStartParams({
    serviceName: name,
    diContainerImport: () => import('./service-setup/diContainer'),
    serviceKey: serviceNames.rampService,
    serviceBusControllerKey: serviceNames.serviceBusController,
    serviceBusBaseClass
});
